import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/auth";
import { LHSLogo } from "@/logos";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function VerifyPage() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [state, setState] = useState({ loading: true, ok: false, msg: "" });

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState({ loading: false, ok: false, msg: "Lien manquant." }); return; }
    (async () => {
      try {
        const { data } = await axios.post(`${API}/auth/verify-link`, { token });
        if (data.kind === "reset") {
          // Redirect to forgot page with prefilled email + token so user can set new password
          nav(`/forgot?token=${encodeURIComponent(token)}&email=${encodeURIComponent(data.email)}`, { replace: true });
          return;
        }
        setState({ loading: false, ok: true, msg: data.already_verified ? "Votre email était déjà vérifié." : "Email confirmé — vous pouvez vous connecter." });
      } catch (e) {
        setState({ loading: false, ok: false, msg: e.response?.data?.detail || "Lien invalide ou expiré." });
      }
    })();
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen bg-black bg-grid flex items-center justify-center px-4 py-8" data-testid="verify-page">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8"><LHSLogo size={64} /></div>
        <div className="card-lhs p-6 sm:p-8 text-center">
          {state.loading ? (
            <>
              <Loader2 className="w-10 h-10 text-orange-500 animate-spin mx-auto mb-4" />
              <div className="text-zinc-300">Vérification du lien…</div>
            </>
          ) : state.ok ? (
            <>
              <CheckCircle2 className="w-14 h-14 text-emerald-400 mx-auto mb-4" />
              <h1 className="font-display text-xl font-extrabold uppercase tracking-wider mb-2">Email vérifié</h1>
              <p className="text-sm text-zinc-400">{state.msg}</p>
              <Link to="/login" data-testid="verify-login-link" className="btn-orange rounded-lg mt-6 inline-block px-6 py-3 text-sm uppercase tracking-wider">Se connecter</Link>
            </>
          ) : (
            <>
              <XCircle className="w-14 h-14 text-red-400 mx-auto mb-4" />
              <h1 className="font-display text-xl font-extrabold uppercase tracking-wider mb-2">Lien invalide</h1>
              <p className="text-sm text-red-400" data-testid="verify-error">{state.msg}</p>
              <Link to="/login" className="text-sm text-zinc-400 hover:text-orange-400 mt-6 inline-block">Retour</Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
